<div class=" !w-screen h-screen dm-sans custom-scroll flex place-content-center items-center absolute top-0 left-0 z-[2]"
    *transloco="let t;prefix:'auth'">
    <div class="h-screen">
        <div title class="text-font63px text-center text-quaternary mt-[163px] mb-[54px]">
            Accedi
        </div>

        <div><std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="'Email'" [placeholder]="'Inserisci email'" customContainerlass="mb-8" [(ngModel)]="email"
                [value]="email" id="email-login" type="email">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input" customContainerlass="relative" customLabel="label-input"
                [label]="'Password'" [placeholder]="'Inserisci password'" [(ngModel)]="password" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="password">
                <div iconRight class="flex place-content-center absolute right-2 z-10 bottom-2.5">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <div (click)="recoveryPassword()"
                class="text-quaternary cursor-pointer w-fit text-font12px opacity-50 mt-[10px] ml-auto">
                {{t('forgetPassword')}}</div>
        </div>
        <div class="ml-auto w-full mt-[90px]">
            <std-button (click)="login()" id="button-login" size="sm"
                buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">{{t('enter')}}</std-button>
            <std-button (click)="registration()" id="button-login" size="sm"
                buttonClass="bg-quintary shadow-xl mt-5 rounded-full place-content-center !text-#white font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Registrati</std-button>
                <!-- <div (click)="registration()" class="text-quaternary w-fit mx-auto text-font12px opacity-50 mt-[10px]">
                {{t('noRegistration')}} <span class="cursor-pointer underline">{{t('clickHere')}}</span></div> -->
        </div>


    </div>
</div>